import { RootState } from '../store'

const loading = (state: RootState) => state.urlMap.loading
const error = (state: RootState) => state.urlMap.error

const data = (state: RootState) => state.urlMap.data


export const UrlMapSelectors = {
  loading,
  data,
  error
}